import { Fandango_overlay as overlay } from '@grins/fd-modules/splits/onering-global';

const Selectors = {
  BTN: '#perks-modal-show-btn',
  CONTENT: '#perks-modal-content',
  MODAL: '#perks-modal',
};

const Styles = {
  CLOSE_BTN: ['perks-info__close-btn', 'icon', 'close-btn-x-white'],
  OVERLAY: 'perks-list__modal-overlay',
};

function onClick() {
  const markup = document.querySelector(Selectors.CONTENT)?.innerHTML;
  overlay.open(markup ?? '', {
    closeBtnParent: Selectors.MODAL,
    closeBtnStyle: Styles.CLOSE_BTN,
    overlayStyle: Styles.OVERLAY,
  });
}

function init() {
  document.querySelector(Selectors.BTN)?.addEventListener('click', onClick);
}

export default {
  init
};
